import * as React from 'react';
import { UIText2 } from '@cian/ui-kit';
import classNames from 'clsx';

import { RateCard } from '../RateCard';
import { RateMark } from '../RateMark';
import * as styles from './InfrastructureFromBuilder.css';

export interface IInfrastructureTerm {
  done: boolean;
  title: string;
}

export interface IInfrastructureFromBuilderProps {
  description: string;
  iconUrl: string;
  rate: string;
  maxRate: string;
  terms: IInfrastructureTerm[];
  title: string;
}

export const InfrastructureFromBuilder: React.VFC<IInfrastructureFromBuilderProps> = ({
  description,
  maxRate,
  iconUrl,
  rate,
  terms,
  title,
}) => {
  return (
    <RateCard
      title={title}
      description={description}
      rateMark={<RateMark iconUrl={iconUrl} rate={rate} maxRate={maxRate} />}
      dataTestId="InfrastructureFromBuilder"
    >
      <ul className={styles['terms']} data-testid="InfrastructureFromBuilderTerms">
        {terms.map((term, idx) => (
          <li key={idx} className={classNames(styles['term-item'], term.done && styles['term-item--done'])}>
            <UIText2 color="current_color">{term.title}</UIText2>
          </li>
        ))}
      </ul>
    </RateCard>
  );
};
